  <div class="row mt-3">
    <div class="col-12">
      <span class="cursor-pointer" (click)="back(communityId)">
        <img src="assets/themes/icons/back-arrow.svg" alt="back-icon" width="15px" />
        {{mls.languageText.community.key28}}
      </span>
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-8">
      <h5 class="pb-3 sticky-top top-90 community-header">
        <span class="color-grey-700 font-weight-700" *ngIf="!communityId">{{this.mls.languageText.community.key34}}</span>
        <span *ngIf="communityId">{{mls.languageText.community.key121}}</span>
      </h5>
    </div>
  </div>
  <div class="row create-community-container mb-5">
    <div class="col-md-10 col-lg-8">
      <div class="bg-white p-4 create-community-form container-shadow">
        <form [formGroup]="communityForm">
          <div class="form-row">
            <div class="col-12 col-md-3 text-center col-container justify-content-md-start justify-content-center">
              <div class="upload-file-container mr-3 d-flex flex-column" *ngIf="!communityPic">
                <label for="file-input">
                  <div class="cursor-pointer my-3">
                    <img src="assets/themes/icons/banner-placeholder.svg" class="biimage" /><br />
                  </div>
                </label>
                <input type="file"
                (click)="bannerEditClicked()"
                  class="form-control d-none" id="file-input"
                  (change)="onSelectEditFile($event)" />
                <label for="file-input" class="mb-3">
                  <div class="btn-design small outline mx-3 ellipsis">{{mls.languageText.community.key23}}</div>
                </label>
              </div>
              <label class="position-relative cursor-pointer" for="file-input" *ngIf="communityPic">
                <a *ngIf="communityId && communityPic"
                  href="javascript:void(0)"
                  (click)="removeCommunityPic()"
                  class="remove-community-pic">
                  <img src="assets/themes/icons/cancel-white.svg" alt="close" />
                </a>
                <img [src]="communityPic"
                  class="post-pic rounded-corners-12"
                  alt="banner"
                  width="150"
                  height="135"
                  onerror="this.src='assets/themes/icons/banner-placeholder.svg'" />
                  <input type="file" (click)="bannerEditClicked()"
                    class="form-control d-none" id="file-input"
                    (change)="onSelectEditFile($event)" />
              </label>
            </div>
            <div class="col-12 col-md-9">
              <div class="form-input col-12 px-0">
                <label class="input-label">{{mls.languageText.community.key122}}*</label>
                <input type="text"
                  formControlName="title"
                  class="input-field"
                  [placeholder]="mls.languageText.community.key129"
                  maxlength="30" />
              </div>

              <div class="col-12 px-0 ">
                <div class="community-type cursor-pointer rounded-corners-12 mt-3 mb-2 pb-3 clearfix" (click)="updatePrivacyPublic()">
                  <div class="asstn-image-div float-left rounded pl-3 py-3">
                    <label for="public-community" class="cursor-pointer">
                      <img src="assets/themes/icons/public-community-icon.svg" alt="public community icon" />
                    </label>
                  </div>
                  <div class="d-flex justify-content-between">
                  <div class="float-left mt-3">
                    <p class="paragraph-bold">
                      <label for="public-community" class="cursor-pointer">
                        <span class="color-grey-700">
                          {{mls.languageText.community.key66}}
                        </span>
                      </label>
                    </p>
                    <p class="primary-small mt-1">
                      <label for="public-community" class="cursor-pointer"> 
                        <span class="color-grey-500">
                          {{mls.languageText.community.key68}}
                        </span>
                      </label>
                    </p>
                  </div>
                  <div class="py-3 mt-2 ml-2 float-right">
                    <label class="radio clearfix mb-0 cursor-pointer" for="public-community">
                        <input [checked]="(!communityId && dss?.backgroundCommunity?.default_privacy_type===privacies.PRIVATE ) || (communityId && privacy===privacies.PUBLIC && type!=communityType.CREATE)
                        || (type==communityType.CREATE && privacy===privacies.PUBLIC)" 
                          name="community"
                          id="public-community"
                          type="radio" />
                          <span></span>
                    </label>
                  </div>
                  </div>
                </div>
                <div class="community-type cursor-pointer rounded-corners-12 mt-3 mb-2 pb-3 clearfix" (click)="updatePrivacyPrivate()">
                  <div class="asstn-image-div float-left rounded pl-3 py-3">
                    <label for="private-community" class="cursor-pointer"> 
                      <img src="assets/themes/icons/private-community-icon.svg" alt="private community icon" />
                    </label>
                  </div>
                  <div class="d-flex justify-content-between">
                  <div class="float-left mt-3">
                    <p class="paragraph-bold">
                      <label for="private-community" class="cursor-pointer">
                        <span class="color-grey-700">
                          {{mls.languageText.community.key67}}
                        </span>
                      </label>
                    </p>
                    <p class="primary-small mt-1">
                      <label for="private-community" class="cursor-pointer">
                        <span class="color-grey-500">
                          {{mls.languageText.community.key69}}
                        </span>
                      </label>
                    </p>
                  </div>
                  <div class="pt-3 pb-3 mt-2 ml-2 float-right">
                    <label class="radio clearfix mb-0 cursor-pointer" for="private-community">
                        <input [checked]="(!communityId && dss?.backgroundCommunity?.default_privacy_type===privacies.PRIVATE) || (communityId && privacy===privacies.PRIVATE && type!=communityType.CREATE)
                        || (type==communityType.CREATE && privacy===privacies.PRIVATE)"
                          name="community"
                          id="private-community"
                          type="radio">
                        <span></span>
                    </label>
                  </div>
                 </div>
                </div>
              </div>

              <label *ngIf="privacy === privacies.PUBLIC" class="col-12 px-0">
                <div class="setting-container float-left pr-2">
                  <a (click)="enterPopup()" class="paragraph cursor-pointer">
                    <span class="color-blue">{{mls.languageText.community.key104}}</span>
                    <img src="assets/themes/icons/settings-icon.svg" class="pb-1 setting-icon"
                      alt="settings icon">
                    </a>
                </div>
              </label>

              <div class="form-textarea col-12 px-0">
                <label class="textarea-label">{{mls.languageText.community.key123}}</label>
                <textarea maxlength="500" formControlName="description" id="community-description" class="textarea-field"
                  placeholder="{{mls?.languageText?.community?.key130}}"></textarea>
              </div>

              <div class="form-input with-icon col-12 px-0 my-2">
                <label class="input-label">{{mls.languageText.community.key20}}</label>
                <app-check-box-select-card
                  *ngIf="isSpecialitySelectionOpen"
                  [isCheckBoxModalOpen]="isSpecialitySelectionOpen"
                  [popupLabel]="specialityPopupLabel"
                  [selectedListLength]="specialityList.length"
                  [selectedLimit]="specialitySelectionLimit"
                  [completeSelectionLabel]="specialityCompleteSelectionLabel"
                  [isButtonDisable]="true"
                  [isSpecialitySelectionOpen]="isSpecialitySelectionOpen"
                  (emitCloseClicked)="closeSpecialityPopup()" 
                  (emitSelected)="setSpeciality()">
                  <app-basic-check-box-select 
                    *ngIf="isSpecialitySelectionOpen" 
                    [title]="specialitySelectionLabel"
                    [suggestionList]="createCommunityService.specialitySuggestionList"
                    [selectedList]="specialityList"
                    [selectedLimit]="specialitySelectionLimit"
                    [noDataFoundLabel]="noSpecialityFound"
                    [maxLimitErrorLabel]="specialityMaxLimitError"
                    [filterPlaceholder]="specialityFilterPlaceholder"
                    [titleErrorLabel]="specialityMaxLimitErrorLabel">
                  </app-basic-check-box-select>
                </app-check-box-select-card>
                <div (click)="openSpecialityPopup()">
                    <input type="text"
                      [attr.disabled]="true"
                      formControlName="speciality"
                      class="input-field cursor-pointer"
                      [placeholder]="mls.languageText.community.key127" />
                  <span class="icon-in-field">
                    <img src="assets/themes/icons/pencil.svg" alt="edit icon" />
                  </span>
                </div>
              </div>
              <div class="form-input col-12 with-icon pt-2 px-0 my-2">
                <label class="input-label">{{mls.languageText.community.key124}}*</label>
                <app-community-member-list
                [isCheckBoxModalOpen]="isMembersSelectionOpen"
                [popupLabel]="membersPopupLabel"
                [selectedListLength]="selectedMembers.length"
                [selectedLimit]="membersSelectedLimit"
                [completeSelectionLabel]="membersSelectionLabel"
                [isButtonDisable]="true"
                (emitCloseClicked)="closeMembersPopup()"
                [callingFrom]="callingFrom"
                [existingCount] = "memberCount"
                (emitSelected)="setMembers(true, $event)"
                [showMobileBackButton]="showMobileBackButtonFlag"
                (onOriginalBack)="emitOriginalBack($event)"
                (emitSelectedarray)="addMember($event)"
                (emitCancelClicked)="clearAll()"
                (emitUpdateMembers)="updateCommunity($event)">
              </app-community-member-list>
                <div (click)="openMembersPopup()">
                  <input type="text"
                    [attr.disabled]="true"
                    formControlName="members"
                    class="input-field cursor-pointer"
                    placeholder="{{mls?.languageText?.community?.key128}}" />
                    <span class="icon-in-field">
                      <img src="assets/themes/icons/pencil.svg" alt="edit icon" />
                    </span>
                </div>
              </div>
            </div>
            <div class="ml-auto mt-4">
              <button
              [ngClass]="(createCommunityService.isCommunityButtonDisable || communityForm.invalid ||
              (memberToBeAdded?.length === numbers.ZERO && !communityId)) ? 'filled-disabled': 'filled'"
              (click)="onSubmit()"
              [disabled]="createCommunityService.isCommunityButtonDisable || communityForm.invalid ||
              (memberToBeAdded?.length === numbers.ZERO && !communityId) || (privacy !== privacies.PUBLIC && privacy !== privacies.PRIVATE) || createCommunityService.postSubmitting !== numbers.ZERO"
              class="btn-design medium">
              <span *ngIf="!communityId">{{mls.languageText.community.key125}}</span>
              <span *ngIf="communityId">{{mls.languageText.community.key126}}</span>
            </button>
            </div>
          </div>
        </form>
      </div>
    </div>

    <app-update-community-pic-modal
      *ngIf="inputFile?.length>0"
      [inputFile]="inputFile"
      [communityData]="communityData"
      [custom_id]="custom_id"
      (cancelUpdateCommunityPic)="cancelUpdateCommunityPic($event)"
      (updateCommunityPic)="updateCommunityPic($event)">
    </app-update-community-pic-modal>

    <app-info-modal
      *ngIf="isInfoModalShown==true"
      [info_msg]="info_msg"
      [isInfoModalShown]="isInfoModalShown"
      (resetInfoModal)="resetInfoModal($event)">
    </app-info-modal>

    <div *ngIf="showJoinModal"
      class="modal fade" tabindex="-1"
      role="dialog"
      [config]="{ show: true, backdrop: 'static' }"
      (onHidden)="onHidden()"
      bsModal
      #autoShownModal="bs-modal">
      <div class="custom-theme-modal modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <span class="cursor-pointer close-modal float-right"
              data-dismiss="modal"
              aria-label="Close"
              (click)="onHidden()">
              <img src="assets/themes/icons/cancel.svg" alt="close icon" />
            </span>
          </div>
          <div class="modal-body pt-0">
            <h4 class="heading-3"> {{mls.languageText.community.key104}}</h4>
            <p class="secondary-paragraph mt-2 mb-3"><span class="color-grey-700">{{mls.languageText.community.key105}}</span></p>
            <label class="radio">
              <input class="radio mr-2"
                [checked]="join_type===joining_option.AUTOMATIC"
                (click)="joinTypeAutomatic()"
                type="radio"
                name="type" />
              <span class="mb-2">{{mls.languageText.community.key106}}</span>
            </label>
            <label class="radio mb-2">
              <input class="radio mr-2"
                [checked]="join_type===joining_option.APPROVAL"
                (click)="joinTypeApproval()"
                type="radio"
                name="type" />
              <span>{{mls.languageText.community.key107}}</span>
            </label>
          </div>
          <div class="modal-footer pb-4">
            <button (click)="onHidden()"
              class="btn-design small filled mr-1 float-right mt-2">{{mls.languageText.community.key12}}</button>
          </div>
        </div>
      </div>
    </div>
    </div>
